import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../app/hooks";

const CustomerRoute: React.FC = () => {
  const accountInfo = useAppSelector((state) => state.accountInfo);
  if (accountInfo.type === "customer" || accountInfo.type === "") {
    return <Outlet />;
  } else if (accountInfo.type === "subcontractor") {
    return <Navigate to="/dashboard/subcontractor" />;
  } else if (accountInfo.type === "employee")
    return <Navigate to="/dashboard/employee" />;
  else return <Navigate to="/" />;
};

export default CustomerRoute;
